import ContentHeader from "@components/ContentHeader";
import { FCX } from "@datassential/platform-ui-lib";
import { useTrendContext } from "@pages/Trend/TrendContext";
import TextInput from "@components/TextInput";
import { FiSearch } from "react-icons/fi";
import SelectFilters from "@vms/SelectFilters";
import { useMemo } from "react";
import { TrendTab } from "@core/constants";
import cn from "classnames";
import DataReflectLabel from "@vms/DataReflectLabel";

const TrendSearchFilters: FCX = ({
	className,
	...props
}) => {
	const {
		search,
		setSearch,
		activeTab,
	} = useTrendContext();

	const filtersLabel = useMemo(
		() => {
			switch (activeTab) {
				case TrendTab.HistoricTrend:
					return "data reflects 2 year change";
				case TrendTab.TrendSummary:
					return <DataReflectLabel />;
				default:
					return 'Filters';
			}
		},
		[activeTab]
	);

	return (
		<ContentHeader
			className={cn(
				"TrendSearchFilters",
				className,
			)}
			{...props}
		>
			<TextInput
				className="TrendSearchFilters__search"
				placeholder="Search an item"
				testId="blockSearchFiltersInput"
				prefix={<FiSearch/>}
				value={search}
				setValue={setSearch}
			/>
			<SelectFilters
				className="TrendSearchFilters__filters"
				testId="buttonSearchFilters"
				label={filtersLabel}
			/>
		</ContentHeader>
	);
};

export default TrendSearchFilters;